import { createNgReactBridgeDirective } from '../../react-bridge'
import { ServerReportsButton } from '../../../components/server-reports'

export const serverReportsButton = createNgReactBridgeDirective(
  'reactServerReportsButton',
  [],
  ServerReportsButton,
  ['isFreemium', 'organizationID', 'serverID']
)
